import React from 'react'

function Schedule({ ScheduleContent, LanguageSelected, t, divstyle }) {
    const Days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

    const existingDays = ScheduleContent.map(item => item.name);

    const uniqueDays = Days.filter(day => !existingDays.includes(day));


    ScheduleContent.sort((a, b) => {
        return Days.indexOf(a.name) - Days.indexOf(b.name);
    });
    return (
        <div>
            {ScheduleContent.length > 0 && (
                <div className={`py-3 px-3 pb-6  ${divstyle} w-full`}>
                    <div className="">
                        <h1
                            className={`${LanguageSelected === 'ar'
                                ? 'title title--h1 first-title title__separate text-theme right-2'
                                : 'title left-2 title--h1 first-title title__separate text-theme'
                                }`}
                        >
                            {t("Horaire Travail S")}
                        </h1>
                    </div>
                    <div className="px-3 w-full ">
                        <div className="grid grid-cols-1 gap-4">
                            <div className="col-span-12 sm:col-span-6 md:col-span-3 gap-2">

                                {ScheduleContent != '' &&

                                    ScheduleContent.map(item => {
                                        return (
                                            <>
                                                <div className='flex justify-start items-center w-full mt-4' key={item.id}>
                                                    <div className=" flex justify-start items-center w-full">
                                                        <div className='flex justify-start items-center gap-2 w-1/2 text-theme '>
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-calendar-clock"><path d="M21 7.5V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h3.5" /><path d="M16 2v4" /><path d="M8 2v4" /><path d="M3 10h5" /><path d="M17.5 17.5 16 16.25V14" /><path d="M22 16a6 6 0 1 1-12 0 6 6 0 0 1 12 0Z" /></svg>                                <p className='text-lg font-semibold '>
                                                                {t(`${item.name}`)}

                                                            </p>
                                                        </div>
                                                        <div className='flex justify-start items-center w-1/2 text-theme '>
                                                            <p className='text-lg text-theme font-normal '>
                                                                {item.start_time} - {item.end_time}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>

                                            </>



                                        )
                                    })}
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>)
}

export default Schedule